<template>
  <el-dialog
    :visible.sync="visible"
    title="提示"
    width="500px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
  >
    <div class="notice-content">
      <p>
        您选购的
        <strong>{{ shopNames }}</strong>
        为平台上的撮合店铺，请关注以下事项，确认符合您的采购需求后再提交订单：
      </p>
      <ol>
        <li>1.商品的结算税率详见商品详情页或下单页；</li>
        <li>
          2.平台撮合店铺的订单由供应商直接向贵单位开具发票并收取货款，货款需由贵单位直接向供应商支付，平台不参与结算及开票环节。
        </li>
      </ol>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="handleConfirm">已阅读</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "PurchaseNoticeDialog",
  props: {
    // 控制弹窗显示/隐藏（父组件传入）
    value: {
      type: Boolean,
      default: false
    },
    // 店铺名称，用于动态显示
    shopNames: {
      type: String,
      default: ""
    }
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val); // 支持 v-model
      }
    }
  },
  methods: {
    handleConfirm() {
      this.$emit("confirm"); // 触发确认事件
      this.visible = false; // 关闭弹窗
    }
  }
};
</script>

<style scoped>
.notice-content {
  font-size: 14px;
  line-height: 1.6;
  color: #333;
}
.notice-content p {
  margin: 0 0 16px 0;
}
.notice-content ol {
  padding-left: 20px;
  margin: 0;
}
.notice-content li {
  margin-bottom: 8px;
}
</style>
